import React, { createElement, useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { graphql, useStaticQuery } from 'gatsby'
import StyledImage from './styled-image'
import { useAcceptCookies } from '../utils/useAcceptedCookies'

export default function Modal() {
  const data = useStaticQuery(graphql`
  {
    wpOption(id: { eq: "cG9zdDo5OA==" }) {
      popup {
        popupImage {
          altText
          localFile {
            publicURL
            extension
            childImageSharp {
              gatsbyImageData(width: 1024)
            }
          }
        }
        popupLink {
          target
          title
          url
        } 
      }
    }
  }
  `)
  const image = data.wpOption.popup.popupImage
  const link = data.wpOption.popup.popupLink
  const [open, setOpen] = useState(false)
  const { acceptedCookies, onAcceptCookies } = useAcceptCookies(image?.localFile.publicURL, 7)
  const ImageWrapper = ({ ...props }) =>
    createElement(link?.url ? "a" : "div", props);
  function handleClose() {
    setOpen(false)
    onAcceptCookies()
  }
  function handleOpen() {
    setTimeout(() => {
      setOpen(true)
    }, 3000)
  }
  handleOpen()

  return image && !acceptedCookies ? (
    <Dialog open={open} onClose={handleClose} className="relative z-40">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity  data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-start mt-20 sm:mt-0 justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative p-4 transform text-left transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <ImageWrapper href={link?.url} target={link?.target} onClick={link?.url ? handleClose : null}
              loading="eager">
              <StyledImage image={image} alt={image.altText} objectFit="contain" />
            </ImageWrapper>
            <div className="absolute right-0 top-0">
              <button
                type="button"
                onClick={handleClose}
                className="bg-gray-500 border-white rounded-full p-1 border  text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-green focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>

          </DialogPanel>
        </div>
      </div>
    </Dialog>
  ) : null
}
